

exports.__esModule = true;
exports.$isPayPalPlus = $isPayPalPlus;

var _index = require('xo-models/src/checkout/index');

function $isPayPalPlus(token) {
    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
    return experienceInitiator === 'PAYPAL_PLUS';
}

angular.value("$isPayPalPlus", $isPayPalPlus);
_index.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/paypalplus.js
// module id = ./pages/xo-login/paypalplus.js
// module chunks = main-code-split